// The text twin of NumberField: shows the value, click to edit, Enter or blur
// applies, Escape cancels.
//
// Deliberately NOT a NumberField with the maths turned off. A name is not a
// quantity: "-3" in a character's name is part of the name, and every rule that
// makes the number field useful - a bare value setting, a sign adjusting - would
// be a trap here. Keeping them as separate components means neither has a flag
// the other has to ignore.
import { useEffect, useRef, useState } from "react";

export function TextField({ value, onApply, label, className, title, placeholder }: { value: string; onApply: (next: string) => void; label: string; className?: string; title?: string; placeholder?: string }) {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState("");
  const input = useRef<HTMLInputElement>(null);
  useEffect(() => { if (editing) { input.current?.focus(); input.current?.select(); } }, [editing]);

  const commit = () => {
    setEditing(false);
    const next = text.trim();
    // An unchanged value is not a change; a blank clears back to the sheet, the
    // same gesture the number fields use.
    if (next !== String(value ?? "")) onApply(next);
  };

  if (!editing) {
    return <button type="button" className={`textfield ${className || ""}`} title={title} aria-label={label}
      onClick={(e) => { e.stopPropagation(); setText(String(value ?? "")); setEditing(true); }}>{String(value ?? "") || <em className="muted">{placeholder || "—"}</em>}</button>;
  }
  return <input ref={input} className={`textfield editing ${className || ""}`} value={text} aria-label={label}
    onClick={(e) => e.stopPropagation()}
    onChange={(e) => setText(e.target.value)}
    onKeyDown={(e) => { if (e.key === "Enter") commit(); if (e.key === "Escape") setEditing(false); }}
    onBlur={commit} />;
}
